<form
  class="tab d-block mb-3"
  id="form"
  action="#"
  #f="ngForm"
  (ngSubmit)="form(f)"
  autocomplete="off"
>
  <section class="container mt-5 pt-2 border-bottom">
    <h4 class="text-red text-center font-weight-bold">Tipo de Inmueble</h4>

    <div
      class="row mt-2 d-flex justify-content-center"
      [class]="
        f.submitted && f.controls['type']?.errors
          ? ' border border-danger p-2 rounded-3'
          : ''
      "
      id="type_property"
    >
      <ng-container *ngFor="let tp of type_properties">
        <div
          *ngIf="
            tp.slug != 'lote' &&
            tp.slug != 'consultorio' &&
            tp.slug != 'parqueadero'
          "
          class="col-3 col-lg px-md-3 justify-content-center d-flex"
        >
          <input
            type="radio"
            class="radio-no-image"
            id="{{ tp.type_property.toLowerCase() }}"
            name="type"
            [(ngModel)]="type_property"
            [value]="tp"
            onchange="$('.other-type-property').addClass('d-none');$('#otheri').val(null);$('.other-type-property-image').show()"
            required
          />
          <label for="{{ tp.type_property.toLowerCase() }}" class="text-center">
            <img src="{{ tp.image }}" class="img-icon" />
            <h6 class="mb-0 mt-1">
              {{ tp.type_property }}
            </h6>
          </label>
        </div>
      </ng-container>
    </div>

    <span
      *ngIf="f.submitted && f.controls['type']?.errors"
      class="text-danger animated fadeIn"
      >Seleccione el tipo de inmueble</span
    >
  </section>
  <section class="container mt-1 py-2">
    <h4 class="text-color-black text-semibold text-center mb-0">
      Administra tus fotos
    </h4>
    <div class="photo" [class]="errorImages ? 'border-danger' : ''">
      <div class="row mb-2">
        <div class="col-md-12 pt-3" *ngIf="croppedImages?.length > 0">
          <div class="row mx-0">
            <ng-container *ngFor="let cp of croppedImages; index as i">
            <div
              class="col-6 col-md-3 col-xl-2 mb-2"
              *ngIf="cp.data == 'files'"
            >
              <div class="photo w-100 container-hover" >
                <img
                  src="{{ cp.type == 'image' ? cp.cropped : getMimeVideo(cp) }}"
                  class="img-selected image-hover"
                  style="min-height: 154px; max-height: 100px"
                />
                <span
                  *ngIf="i == 0"
                  style="
                    position: absolute;
                    top: 0;
                    background: #ffffffcc;
                    line-height: 1;
                    font-weight: 700;
                    font-size: 0.75em;
                    right: 0;
                    left: 0;
                    text-align: center;
                    padding: 0.25em 0;
                  "
                  >Esta es tu imagen destacada</span
                >
                <div class="row mx-0 mt-2 justify-content-center">
                  <div
                    data-toggle="modal"
                    data-target="#imagesModal"
                    data-backdrop="static"
                    data-keyboard="false"
                    class="col-4 px-2 mb-2 text-color-black text-medium cursor-pointer"
                    *ngIf="cp.event && cp.type == 'image'"
                    (click)="editCroppedImage(cp, i)"
                  >
                    <a
                      class="bg-yellow text-white text-bold w-100 d-block px-2 img-option text-center"
                    >
                      <i class="fas fa-edit"></i>
                    </a>
                  </div>
                  <div
                    class="col-4 px-2 mb-2 text-color-black text-medium cursor-pointer"
                    *ngIf="!edit"
                    (click)="croppedImages.splice(i, 1)"
                  >
                    <a
                      class="bg-yellow text-white text-bold w-100 d-block px-2 img-option text-center"
                    >
                      <i class="fas fa-trash"></i>
                    </a>
                  </div>
                  <div
                    class="col-4 px-2 mb-2 text-color-black text-medium cursor-pointer"
                    *ngIf="!edit && i != 0"
                    (click)="changePosition(i)"
                  >
                    <a
                      class="bg-yellow text-white text-bold w-100 d-block px-2 img-option text-center"
                    >
                      <i class="fas fa-star"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            </ng-container>
          </div>
        </div>
        <div class="row justify-content-center col-lg-12">
          <div class="col-lg-auto">
            <label
              for="file"
              class="d-block btn-yellow p-sm-90 text-center mx-auto p-2 mt-2 mb-0 cursor-pointer"
              style="width: 150px"
              >Subir foto</label
            >
          </div>
          <div class="col-lg-auto">
            <button
              type="button"
              style="width: 150px"
              data-backdrop="static"
              data-keyboard="false"
              class="d-block btn-yellow text-black mx-auto p-2 mt-2 mb-0 cursor-pointer"
              data-toggle="modal"
              data-target="#videoModal"
              [disabled]="hasVideoItem()"
            >
              Subir Vídeo
            </button>
            <input
              type="file"
              accept="image/*"
              style="display: none"
              multiple
              id="file"
              (change)="fileChangeEvent($event, 'files')"
            />
          </div>
        </div>
        <span class="col-12 text-center mt-1 text-info"
          >Para cambiar tu imagen destacada, pasa el cursor sobre la imagen
          deseada y haz clic en el ícono
          <a class="bg-yellow text-white p-1">
            <i class="fas fa-star"></i>
          </a>
        </span>
        <span class="text-danger px-5" *ngIf="errorImages">Se ha producido un error al cargar las imágenes, puede que alguna de ellas no tenga un formato de imagen permitido o supere el peso máximo de carga, el cual es de <b>3.5Mb</b>.</span>
      </div>
    </div>
  </section>
  <section class="container mt-1 pb-2 border-bottom">
    <h4 class="text-red text-center font-weight-bold">
      Ubicación del Inmueble
    </h4>

    <div class="row">
      <div class="col-lg-6">
        <div class="form-group">
          <input
            type="text"
            name="address"
            id="address"
            placeholder="Introduce una dirección"
            ngModel
            class="px-2 w-100"
            [class]="
              f.submitted && f.controls['address']?.errors
                ? 'border-danger'
                : ''
            "
            autocorrect="off"
            autocapitalize="off"
            spellcheck="off"
            #search
            required
          />

          <span
            *ngIf="f.submitted && f.controls['address']?.errors"
            class="text-danger animated fadeIn"
            >Campo obligatorio</span
          >
        </div>
      </div>

      <div class="col-lg-6">
        <div class="form-group">
          <input
            type="text"
            name="city"
            id="city"
            placeholder="Ciudad"
            class="px-2 w-100"
            [class]="
              f.submitted && f.controls['city']?.errors ? 'border-danger' : ''
            "
            [(ngModel)]="city"
            required
          />
          <span
            *ngIf="f.submitted && f.controls['city']?.errors"
            class="text-danger animated fadeIn"
            >Campo obligatorio</span
          >
        </div>
      </div>
 
      <div class="col-lg-6">
        <div class="form-group">
          <input
            type="text"
            name="zone"
            id="zone"
            placeholder="Zona residencial o barrio"
            [class]="
              f.submitted && f.controls['zone']?.errors ? 'border-danger' : ''
            "
            class="px-2 w-100"
            [(ngModel)]="zone"
            required
          />
          <span
            *ngIf="f.submitted && f.controls['zone']?.errors"
            class="text-danger animated fadeIn"
            >Campo obligatorio</span
          >
        </div>
      </div>
      <div class="col-lg-6">
        <div class="form-group">
          <input
            type="text"
            name="complement"
            id="complement"
            placeholder="Complemento de la dirección"
            [class]="
              f.submitted && f.controls['complement']?.errors
                ? 'border-danger'
                : ''
            "
            class="px-2 w-100"
            [(ngModel)]="complement"
            required
          />
          <span
            *ngIf="f.submitted && f.controls['complement']?.errors"
            class="text-danger animated fadeIn"
            >Campo obligatorio</span
          >
        </div>
      </div>
    </div>

    <div class="text-blue pb-2 lh-1 text-center text-lg-left">
      Puedes mover el marcador en la ubicación correcta de tu inmueble.
    </div>

    <div class="mx-auto contiene-map">
      <agm-map
        [latitude]="lat"
        [longitude]="lng"
        [zoom]="zoom"
        [mapTypeId]="'hybrid'"
        [disableDefaultUI]="true"
      >
        <agm-marker
          [latitude]="lat"
          [longitude]="lng"
          [markerDraggable]="true"
          (dragEnd)="markerDragEnd($event)"
        ></agm-marker>
      </agm-map>
    </div>
    <div class="my-2">
      <div class="row align-items-center small">
        <div class="col-lg-4 text-blue text-center text-lg-left">
          <b> Debes confirmar la ubicación del inmueble </b>
        </div>
        <div class="col-lg-5 text-center text-lg-left">
          Has ubicado el inmueble en:
          <br class="d-md-none" />
          {{ address || "(Ingresa una dirección en la parte superior)" }}
        </div>
        <div class="col-lg-3">
          <div
            class="d-flex justify-content-center align-items-center mt-3 mt-lg-0"
          >
            <input
              type="checkbox"
              id="confirm-address"
              name="confirm-address"
              required
            />
            <label for="confirm-address" class="pb-0 mb-0"> </label>
            <label for="confirm-address" class="ml-2 pb-0 mb-0">
              Confirmar ubicación del inmueble
            </label>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="container py-2 border-bottom">
    <h4 class="text-red text-center font-weight-bold">
      Información del Inmueble
    </h4>

    <div class="row">
      <div class="col-lg-6">
        <h6 class="mb-0 d-lg-none">
          <span class="text-red">*</span> Precio del inmueble
        </h6>

        <div class="input-group input-currency mb-3">
          <div class="input-group-prepend">
            <select
              name="currency"
              id="currency"
              class="custom-select"
              [(ngModel)]="currency"
              required
              [class]="
                f.submitted && f.controls['currency']?.errors
                  ? 'border-danger'
                  : ''
              "
              (change)="getSelectedValue($event)"
            >
              <option
                [value]="currency.iso"
                [title]="currency.name"
                *ngFor="let currency of currencies"
              >
                {{ currency.iso }}
              </option>
              <i class="fas fa-chevron-down"></i>
            </select>
          </div>
          <input
            type="text"
            name="currency_value"
            id="currency_value"
            class="col px-2"
            [class]="
              f.submitted && f.controls['currency_value']?.errors
                ? 'border-danger'
                : ''
            "
            [placeholder]="'Valor del inmueble (' + currencyPlaceholder + ') *'"
            [(ngModel)]="value"
            onkeyup="var value = parseInt(this.value.replace(/\D/g,''), 10);value = isNaN(value) ? '' : value;this.value = value.toLocaleString();"
            required
          />
          <span
            *ngIf="f.submitted && f.controls['currency_value']?.errors"
            class="text-danger animated fadeIn"
            >Campo obligatorio</span
          >
        </div>
        <div class="">
          <div
            class="d-md-flex align-items-center"
            [class]="
              f.submitted && f.controls['estrato']?.errors
                ? 'border border-danger rounded-3 px-3 pb-2'
                : ''
            "
          >
            <h6 class="mb-0 mr-md-3">
              <span class="text-red">*</span> Estrato:
            </h6>

            <div class="row mx-0 label-estrato col-md px-0">
              <div class="col px-0" *ngFor="let i of [1, 2, 3, 4, 5, 6]">
                <input
                  type="radio"
                  name="estrato"
                  id="{{ i }}"
                  class="radio-no-image"
                  [(ngModel)]="estrato"
                  value="{{ i }}"
                  required
                  (input)="errorEstrato = false"
                />
                <label
                  for="{{ i }}"
                  class="w-100 text-center text-yellow border py-2 px-3 label-blue"
                  >{{ i }}</label
                >
              </div>
            </div>
          </div>
          <div
            *ngIf="f.submitted && f.controls['estrato']?.errors"
            class="text-danger animated fadeIn"
          >
            Campo obligatorio
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <textarea
          name="description"
          id="description"
          placeholder="Descripción del inmueble"
          [(ngModel)]="description"
          rows="3"
          class="w-100 px-3 form-control mt-3 mt-lg-0"
          maxlength="2000"
        ></textarea>
        <h6 class="number text-right">
          <span id="charNum">{{ description.length }}</span
          >/2000
        </h6>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <select
          name="estado"
          id="estado"
          class="w-100 px-2 mb-3 mb-md-2"
          [(ngModel)]="estado"
          required
          [class]="
            f.submitted && f.controls['estado']?.errors ? 'border-danger' : ''
          "
        >
          <option value="" disabled>Estado del inmueble</option>
          <option value="planos">Sobre planos</option>
          <option value="obra-gris">En obra gris</option>
          <option value="acabados">Acabados</option>
        </select>
      </div>
      <div class="col-md-6">
        <select
          name="tipovivienda"
          id="tipovivienda"
          class="w-100 px-2 mb-2"
          [(ngModel)]="tipovivienda"
          required
          [class]="
            f.submitted && f.controls['tipovivienda']?.errors
              ? 'border-danger'
              : ''
          "
        >
          <option value="" disabled>Tipo de Vivienda</option>
          <option value="no-vis">Vivienda NO VIS</option>
          <option value="vis">Vivienda VIS</option>
          <option value="vip">Vivienda VIP</option>
        </select>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-md-6 col-xl-3 mb-3 mb-xl-0">
        <input
          type="text"
          placeholder="Área en M2"
          inputmode="numeric"
          name="area"
          id="area"
          [(ngModel)]="area.total"
          [class]="
            f.submitted && f.controls['area']?.errors ? 'border-danger' : ''
          "
          class="px-3 w-100"
          oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
          required
          (input)="errorArea = false"
        />
        <span
          *ngIf="f.submitted && f.controls['area']?.errors"
          class="text-danger animated fadeIn"
          >Campo obligatorio</span
        >
      </div>
      <div class="col-md-6 col-xl-3 mb-3 mb-xl-0">
        <div class="row justify-content-between align-items-center">
          <div class="col-6 pr-0">
            <p class="mb-0">N° habitaciones:</p>
          </div>
          <div class="col-6">
            <div
              class="input-group border text-center justify-content-between rounded-20"
            >
              <span class="input-group-btn">
                <button
                  type="button"
                  class="btn text-secondary"
                  [disabled]="habitaciones == 0"
                  (click)="habitaciones = habitaciones - 1"
                >
                  <i class="fas fa-minus small"></i>
                </button>
              </span>
              <input
                type="text"
                inputmode="numeric"
                name="habitaciones"
                id="habitaciones"
                [(ngModel)]="habitaciones"
                value="{{ habitaciones }}"
                class="w-25 text-center m-0 border-0"
                required
              />
              <span class="input-group-btn">
                <button
                  type="button"
                  class="btn text-secondary"
                  data-type="plus"
                  data-field="quant[1]"
                  (click)="habitaciones = habitaciones + 1"
                >
                  <i class="fas fa-plus small"></i>
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-xl-3 mb-3 mb-xl-0">
        <div class="row justify-content-between align-items-center">
          <div class="col-6 pr-0">
            <p class="mb-0">N° baños:</p>
          </div>
          <div class="col-6">
            <div
              class="input-group border text-center justify-content-between rounded-20"
            >
              <span class="input-group-btn">
                <button
                  type="button"
                  class="btn text-secondary"
                  [disabled]="banos == 0"
                  (click)="banos = banos - 1"
                >
                  <i class="fas fa-minus small"></i>
                </button>
              </span>
              <input
                type="text"
                inputmode="numeric"
                name="banos"
                id="banos"
                [(ngModel)]="banos"
                value="{{ banos }}"
                class="w-25 text-center m-0 border-0"
                required
              />
              <span class="input-group-btn">
                <button
                  type="button"
                  class="btn text-secondary"
                  (click)="banos = banos + 1"
                >
                  <i class="fas fa-plus small"></i>
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-xl-3 mb-3 mb-xl-0">
        <div class="row justify-content-between align-items-center">
          <div class="col-6 pr-0">
            <p class="mb-0">N° parqueaderos:</p>
          </div>
          <div class="col-6">
            <div
              class="input-group border text-center justify-content-between rounded-20"
            >
              <span class="input-group-btn">
                <button
                  type="button"
                  class="btn text-secondary"
                  [disabled]="parqueaderos == 0"
                  (click)="parqueaderos = parqueaderos - 1"
                >
                  <i class="fas fa-minus small"></i>
                </button>
              </span>
              <input
                type="text"
                inputmode="numeric"
                name="parqueaderos"
                id="parqueaderos"
                [(ngModel)]="parqueaderos"
                value="{{ parqueaderos }}"
                class="w-25 text-center m-0 border-0"
                required
              />
              <span class="input-group-btn">
                <button
                  type="button"
                  class="btn text-secondary"
                  (click)="parqueaderos = parqueaderos + 1"
                >
                  <i class="fas fa-plus small"></i>
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-xl-4 mb-lg-2">
      <div class="col-md-6 col-xl-3 mb-3 mb-xl-0">
        <div class="row justify-content-between align-items-center">
          <div class="col-6 pr-0">
            <p class="mb-0">N° balcones:</p>
          </div>
          <div class="col-6">
            <div
              class="input-group border text-center justify-content-between rounded-20"
            >
              <span class="input-group-btn">
                <button
                  type="button"
                  class="btn text-secondary"
                  [disabled]="balcones == 0"
                  (click)="balcones = balcones - 1"
                >
                  <i class="fas fa-minus small"></i>
                </button>
              </span>
              <input
                type="text"
                inputmode="numeric"
                name="balcones"
                id="balcones"
                [(ngModel)]="balcones"
                value="{{ balcones }}"
                class="w-25 text-center m-0 border-0"
                required
              />
              <span class="input-group-btn">
                <button
                  type="button"
                  class="btn text-secondary"
                  (click)="balcones = balcones + 1"
                >
                  <i class="fas fa-plus small"></i>
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-xl-3 mb-3 mb-xl-0">
        <div class="row justify-content-between align-items-center">
          <div class="col-6 pr-0">
            <p class="mb-0">N° ascensores:</p>
          </div>
          <div class="col-6">
            <div
              class="input-group border text-center justify-content-between rounded-20"
            >
              <span class="input-group-btn">
                <button
                  type="button"
                  class="btn text-secondary"
                  [disabled]="ascensores == 0"
                  (click)="ascensores = ascensores - 1"
                >
                  <i class="fas fa-minus small"></i>
                </button>
              </span>
              <input
                type="text"
                inputmode="numeric"
                name="ascensores"
                id="ascensores"
                [(ngModel)]="ascensores"
                value="{{ ascensores }}"
                class="w-25 text-center m-0 border-0"
                required
              />
              <span class="input-group-btn">
                <button
                  type="button"
                  class="btn text-secondary"
                  (click)="ascensores = ascensores + 1"
                >
                  <i class="fas fa-plus small"></i>
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-xl-3 mb-3 mb-xl-0">
        <div class="row justify-content-between align-items-center">
          <div class="col-6 pr-0">
            <p class="mb-0">N° terrazas:</p>
          </div>
          <div class="col-6">
            <div
              class="input-group border text-center justify-content-between rounded-20"
            >
              <span class="input-group-btn">
                <button
                  type="button"
                  class="btn text-secondary"
                  [disabled]="terrazas == 0"
                  (click)="terrazas = terrazas - 1"
                >
                  <i class="fas fa-minus small"></i>
                </button>
              </span>
              <input
                type="text"
                inputmode="numeric"
                name="terrazas"
                id="terrazas"
                [(ngModel)]="terrazas"
                value="{{ terrazas }}"
                class="w-25 text-center m-0 border-0"
                required
              />
              <span class="input-group-btn">
                <button
                  type="button"
                  class="btn text-secondary"
                  (click)="terrazas = terrazas + 1"
                >
                  <i class="fas fa-plus small"></i>
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-xl-3 mb-3 mb-xl-0">
        <div class="row justify-content-between align-items-center">
          <div class="col-6 pr-0">
            <p class="mb-0">N° depositos:</p>
          </div>
          <div class="col-6">
            <div
              class="input-group border text-center justify-content-between rounded-20"
            >
              <span class="input-group-btn">
                <button
                  type="button"
                  class="btn text-secondary"
                  [disabled]="depositos == 0"
                  (click)="depositos = depositos - 1"
                >
                  <i class="fas fa-minus small"></i>
                </button>
              </span>
              <input
                type="text"
                inputmode="numeric"
                name="depositos"
                id="depositos"
                [(ngModel)]="depositos"
                value="{{ depositos }}"
                class="w-25 text-center m-0 border-0"
                required
              />
              <span class="input-group-btn">
                <button
                  type="button"
                  class="btn text-secondary"
                  (click)="depositos = depositos + 1"
                >
                  <i class="fas fa-plus small"></i>
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>


  <!-- Planos -->
  <section class="container mt-2 py-2">
    <h4 class="text-color-black text-semibold mb-0 text-center">Planos del inmueble</h4>
    <h6 class="text-color-black font-weight-normal mb-2 text-center">(Si aplica)</h6>
    <div class="row">
      <div class="col-12">
        <div class="photo">
          <div class="row mb-2">
            <div class="col-md-12 pt-3" *ngIf="croppedImages?.length > 0">
              <div class="row mx-0">
                <ng-container *ngFor="let cp of croppedImages; index as i">
                  <div class="col-12 col-lg-6 mb-2" *ngIf="cp.data == 'planes_files'">
                    <div class="photo w-100 container-hover">
                      <div class="container">
                        <div class="row align-items-center">
                          <div class="col-md-12">
                            <img
                              src="{{
                                cp.type == 'image'
                                  ? cp.cropped
                                  : getMimeVideo(cp)
                              }}"
                              class="img-selected image-hover mt-1"
                              style="min-height: 154px; max-height: 100px"
                            />
                            <span
                              *ngIf="i == 0"
                              style="
                                position: absolute;
                                top: 0;
                                background: #ffffffcc;
                                line-height: 1;
                                font-weight: 700;
                                font-size: 0.75em;
                                right: 0;
                                left: 0;
                                text-align: center;
                                padding: 0.25em 0;
                              "
                              class="mt-1"
                              >Esta es tu imagen destacada</span
                            >
                          </div>
                          <div class="col-md-12">
                            <div class="row">
                              <div class="col-lg-4">
                                <div class="form-group">
                                  <p class="mb-0">Área construida</p>
                                  <input
                                    type="number"
                                    id="area_construida"
                                    class="m-0 w-100"
                                    name="area_construida"
                                    [(ngModel)]="cp.area_construida"
                                  />
                                </div>
                              </div>
                              <div class="col-lg-4">
                                <div class="form-group">
                                  <p class="mb-0">Área A.A.:</p>
                                  <input
                                    type="number"
                                    id="area_aa"
                                    name="area_aa"
                                    class="m-0 w-100"
                                    [(ngModel)]="cp.area_aa"
                                  />
                                </div>
                              </div>
                              <div class="col-lg-4">
                                <div class="form-group">
                                  <p class="mb-0" >Área Privada:</p>
                                  <input
                                    type="number"
                                    id="area_privada"
                                    name="area_privada"
                                    class="m-0 w-100"
                                    [(ngModel)]="cp.area_privada"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mx-0 mt-2 justify-content-center">
                        <div
                          data-toggle="modal"
                          data-target="#imagesModal"
                          data-backdrop="static"
                          data-keyboard="false"
                          class="col-4 px-2 mb-2 text-color-black text-medium cursor-pointer"
                          *ngIf="cp.event && cp.type == 'image'"
                          (click)="editCroppedImage(cp, i)"
                        >
                          <a
                            class="bg-yellow text-white text-bold w-100 d-block px-2 img-option text-center"
                          >
                            <i class="fas fa-edit"></i>
                          </a>
                        </div>
                        <div
                          class="col-4 px-2 mb-2 text-color-black text-medium cursor-pointer"
                          *ngIf="!edit"
                          (click)="croppedImages.splice(i, 1)"
                        >
                          <a
                            class="bg-yellow text-white text-bold w-100 d-block px-2 img-option text-center"
                          >
                            <i class="fas fa-trash"></i>
                          </a>
                        </div>
                        <div
                          class="col-4 px-2 mb-2 text-color-black text-medium cursor-pointer"
                          *ngIf="!edit && i != 0"
                          (click)="changePosition(i)"
                        >
                          <a
                            class="bg-yellow text-white text-bold w-100 d-block px-2 img-option text-center"
                          >
                            <i class="fas fa-star"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="row justify-content-center col-lg-12">
              <div class="col-lg-auto">
                <label
                  for="planes_files"
                  class="d-block btn-yellow p-sm-90 text-center mx-auto p-2 mt-2 mb-0 cursor-pointer"
                  style="width: 150px"
                  >Subir foto</label
                >
                <input
                  type="file"
                  accept="image/*"
                  style="display: none"
                  multiple
                  id="planes_files"
                  (change)="fileChangeEvent($event, 'planes_files')"
                />
              </div>
            </div>
            <span class="col-12 text-center mt-1 text-info"
              >Para cambiar tu imagen destacada, pasa el cursor sobre la imagen
              deseada y haz clic en el ícono
              <a class="bg-yellow text-white p-1">
                <i class="fas fa-star"></i>
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- planos end -->

  <section class="container py-2" *ngIf="false">
    <h4 class="text-red text-center font-weight-bold">Planes</h4>

    <div class="row mx-0">
      <div class="col-3 px-0">
        <input
          type="radio"
          class="radio-no-image"
          name="planes"
          id="planes-gratis"
          [(ngModel)]="planes"
          [value]="'gratis'"
          required
        />
        <label
          for="planes-gratis"
          class="w-100 text-center border py-2 label-blue left"
        >
          Plan Gratis
        </label>
      </div>
      <div class="col-3 px-0">
        <input
          type="radio"
          class="radio-no-image"
          name="planes"
          id="planes-mensual"
          [(ngModel)]="planes"
          [value]="'mensual'"
          required
        />
        <label
          for="planes-mensual"
          class="w-100 text-center border py-2 label-blue rounded-0"
        >
          Plan Mensual
        </label>
      </div>
      <div class="col-3 px-0">
        <input
          type="radio"
          class="radio-no-image"
          name="planes"
          id="planes-trimestral"
          [(ngModel)]="planes"
          [value]="'trimestral'"
          required
        />
        <label
          for="planes-trimestral"
          class="w-100 text-center border py-2 label-blue rounded-0"
        >
          Plan Trimestral
        </label>
      </div>
      <div class="col-3 px-0">
        <input
          type="radio"
          class="radio-no-image"
          name="planes"
          id="planes-anual"
          [(ngModel)]="planes"
          [value]="'anual'"
          required
        />
        <label
          for="planes-anual"
          class="w-100 text-center border py-2 label-blue right"
        >
          Plan Anual
        </label>
      </div>
    </div>
  </section>

  <section class="container mt-3">
    <div class="text-center text-lg-right">
      <button
        type="submit"
        class="btn btn-red btn-rounded font-italic small px-4"
      >
        PUBLICAR
      </button>
    </div>
  </section>
</form>

<div
  class="modal fade bd-example-modal-lg p-0"
  id="imagesModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  aria-hidden="true"
>
  <div
    class="modal-dialog modal-lg py-3 px-0 px-md-5"
    style="max-width: fit-content !important"
  >
    <div class="modal-content p-2 p-md-3">
      <div class="row px-md-5 px-3" *ngIf="imageChangedEvent.length > 0">
        <div class="col-12">
          <h3 class="text-black text-color-black text-center mt-3">
            Editor de fotos
          </h3>
          <h6 class="text-regular text-color-black text-center mb-3">
            Realiza el recorte de tu imagen para ser visualizada dentro de
            nuestro portal.
          </h6>
        </div>
        <div class="col-6 px-1 px-md-5 px-2">
          <image-cropper
            [imageChangedEvent]="imageChangedEvent[0]"
            [maintainAspectRatio]="true"
            [containWithinAspectRatio]="false"
            [aspectRatio]="1 / 1"
            [resizeToWidth]="256"
            [cropperMinWidth]="128"
            [onlyScaleDown]="true"
            [roundCropper]="false"
            [transform]="transform"
            [canvasRotation]="canvasRotation"
            format="png"
            (cropperReady)="cropperReady()"
            (imageCropped)="imageCropped($event, 0, '1x1')"
          ></image-cropper>
          <div
            class="d-flex mx-auto justify-content-center align-items-center mt-4"
          >
            <img
              src="https://cdn.vivienda.com/images/icons/house.png"
              alt=""
              class="img-border d-none d-md-block"
              width="80px"
            />
            <div
              class="d-flex flex-column justify-content-center align-items-center ml-3"
            >
              <p class="text-regular text-gray mb-1">Cuadrado</p>
              <p class="text-regular text-gray mb-1">1:1</p>
            </div>
          </div>
        </div>
        <div class="col-6 px-1 px-md-5 px-2">
          <image-cropper
            [imageChangedEvent]="imageChangedEvent[1]"
            [maintainAspectRatio]="true"
            [containWithinAspectRatio]="false"
            [aspectRatio]="16 / 9"
            [resizeToWidth]="256"
            [cropperMinWidth]="128"
            [onlyScaleDown]="true"
            [roundCropper]="false"
            [transform]="transform"
            [canvasRotation]="canvasRotation"
            format="png"
            (cropperReady)="cropperReady()"
            (imageCropped)="imageCropped($event, 1, '16x9')"
          ></image-cropper>
          <div
            class="d-flex mx-auto justify-content-center align-items-center mt-4"
          >
            <img
              src="https://cdn.vivienda.com/images/icons/house-16-9.png"
              alt=""
              class="img-border d-none d-md-block"
              width="125px"
            />
            <div
              class="d-flex flex-column justify-content-center align-items-center ml-3"
            >
              <p class="text-regular text-gray mb-1">Paisaje</p>
              <p class="text-regular text-gray mb-1">16:9</p>
            </div>
          </div>
        </div>
      </div>
      <div class="row my-2 text-center">
        <div class="col-3">
          <button (click)="rotateLeft()" class="btn btn-yellow-outline btn-sm px-0 px-md-1" >Girar a la izquierda <i class="fas fa-undo-alt ml-1"></i></button>
        </div>
        <div class="col-3">
          <button (click)="rotateRight()" class="btn btn-yellow-outline btn-sm px-0 px-md-1">Girar a la derecha <i class="fas fa-redo-alt ml-1"></i></button>
        </div>
        <div class="col-3">
          <button (click)="flipHorizontal()" class="btn btn-yellow-outline btn-sm px-0 px-md-1" >Voltear Horizontal <i class="fas fa-exchange-alt ml-1"></i></button>
        </div>
        <div class="col-3">
          <button (click)="flipVertical()" class="btn btn-yellow-outline btn-sm px-md-1">Voltear Vertical <i class="fas fa-exchange-alt ml-1" style="transform: rotate(90deg);"></i></button>
        </div>
        <div class="col-12 text-center mt-2">
            <button (click)="resetImage()" class="rounded-8 border border-secondary btn-sm bg-transparent text-secondary" >Restaurar imagen <i class="fa fa-window-restore ml-1" aria-hidden="true"></i></button>
        </div>
      </div>
      <div class="col-12 text-center flex-row">
        <a
          type="button"
          class="bg-white text-yellow mt-1 mb-3 py-2 text-bold"
          data-dismiss="modal"
          style="width: 180px"
          >Cancelar</a
        >
        <button
          type="button"
          class="btn-yellow mt-1 mb-3 py-2 text-bold"
          data-dismiss="modal"
          (click)="useCropper()"
          style="width: 180px"
        >
          Aceptar
        </button>
      </div>
    </div>
  </div>
</div>